import React, {useState, useRef, useEffect} from 'react'
import { IoSend, IoImageOutline } from "react-icons/io5";
import { EmojiClickData } from 'emoji-picker-react';
import EmojiPicker from 'emoji-picker-react';
import axios from "axios";
import {useDispatch, useSelector} from "react-redux";
import { setMessages ,addNewMessage, deleteMessage} from '../redux/messageSlice';
import { BASE_URL } from '../config';
import toast from 'react-hot-toast';
import { debounce } from 'lodash'; 

const SendInput = () => {
    const [message, setMessage] = useState("");
    const [file, setFile] = useState(null);
    const [preview, setPreview] = useState(null);
    const [showEmojiPicker, setShowEmojiPicker] = useState(false);
    const [isMobileKeyboardOpen, setIsMobileKeyboardOpen] = useState(false);
    const [isSending, setIsSending] = useState(false); // New loading state
     const [showFormatOptions, setShowFormatOptions] = useState(false);
    const [formattedContent, setFormattedContent] = useState("");
    const fileInputRef = useRef(null);
     const editorRef = useRef(null);
    const textareaRef = useRef(null);
    const emojiPickerRef = useRef(null);
    const formatOptionsRef = useRef(null);
    const formRef = useRef(null);
    const dispatch = useDispatch();
    const {selectedUser, authUser} = useSelector(store=>store.user);
    const {messages} = useSelector(store=>store.message);
    const [originalMessageId, setOriginalMessageId] = useState(null);
    const { socket } = useSelector(store => store.socket);
      const [isEditorFocused, setIsEditorFocused] = useState(false);
      const [showPlaceholder, setShowPlaceholder] = useState(true);
      const savedSelectionRef = useRef(null);
    

    // Check if user is on mobile device
    const isMobile = () => {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    };



    // Updated SMS notification function
const sendSMSNotification = async (mobileNumber, messageContent) => {
    try {
      await axios.post(
        `${BASE_URL}/api/v1/send-notification`, // Your backend proxy route
        {
          mobile_number: mobileNumber,
          message: messageContent
        },
        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/json",
            "accept": "application/json"
          }
        }
      );
    } catch (error) {
      console.error("SMS notification failed:", error);
    }
  };

//   useEffect(() => {
//     if (!socket || !authUser || !selectedUser) return;

//     let timeout;
//     const handleTyping = () => {
//         if (message.trim()) {
//             // Remove timeout for immediate emission
//             socket.emit('typing', {
//                 senderId: authUser._id,
//                 receiverId: selectedUser._id,
//                 nickname: authUser.nickname || authUser.username
//             });
//         }
//     };

//     // Trigger on every keystroke with debounce
//     // const debouncedTyping = _.debounce(handleTyping, 300);
//     const debouncedTyping = debounce(handleTyping, 300); 
    
//     if (message.trim()) {
//         debouncedTyping();
//     } else {
//         socket.emit('stopTyping', {
//             senderId: authUser._id,
//             receiverId: selectedUser._id
//         });
//     }

//     return () => {
//         debouncedTyping.cancel();
//         socket.emit('stopTyping', {
//             senderId: authUser._id,
//             receiverId: selectedUser._id
//         });
//     };
// }, [message, socket, authUser, selectedUser]);

useEffect(() => {
    if (!socket || !authUser || !selectedUser) return;

    let typing = false;
    let timeout;

    const handleKeyPress = () => {
        if (!typing) {
            typing = true;
            socket.emit('typing', {
                senderId: authUser._id,
                receiverId: selectedUser._id,
                nickname: authUser.nickname || authUser.username
            });
        }
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            typing = false;
            socket.emit('stopTyping', {
                senderId: authUser._id,
                receiverId: selectedUser._id
            });
        }, 3000); // Send stopTyping after 1 second of inactivity
    };

            const editor = editorRef.current;
        // editor.addEventListener('keydown', handleKeyPress);
          if (editor) {
            editor.addEventListener('keydown', handleKeyPress);
        }

        return () => {
            // editor.removeEventListener('keydown', handleKeyPress);
             if (editor) {
                editor.removeEventListener('keydown', handleKeyPress);
            }
            clearTimeout(timeout);
            if (typing) {
                socket.emit('stopTyping', {
                    senderId: authUser._id,
                    receiverId: selectedUser._id
                });
            }
        };
    }, [message, socket, authUser, selectedUser]);


//     const textarea = textareaRef.current;
//     textarea.addEventListener('keydown', handleKeyPress);

//     return () => {
//         textarea.removeEventListener('keydown', handleKeyPress);
//         clearTimeout(timeout);
//         if (typing) {
//             socket.emit('stopTyping', {
//                 senderId: authUser._id,
//                 receiverId: selectedUser._id
//             });
//         }
//     };
// }, [message, socket, authUser, selectedUser]);

    // Handle clicks outside emoji picker to close it
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (emojiPickerRef.current && !emojiPickerRef.current.contains(event.target) && 
                !event.target.closest('.emoji-trigger')) {
                setShowEmojiPicker(false);
                savedSelectionRef.current = null;
            }

             if (formatOptionsRef.current && !formatOptionsRef.current.contains(event.target) && 
                !event.target.closest('.format-trigger')) {
                setShowFormatOptions(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    // Handle mobile keyboard visibility changes
    // useEffect(() => {
    //     if (!isMobile()) return;

    //     const handleFocus = () => {
    //         setIsMobileKeyboardOpen(true);
    //         setShowEmojiPicker(false);
    //     };

    //     const handleBlur = () => {
    //         setIsMobileKeyboardOpen(false);
    //     };

    //     const textarea = textareaRef.current;
    //     textarea.addEventListener('focus', handleFocus);
    //     textarea.addEventListener('blur', handleBlur);

    //     return () => {
    //         textarea.removeEventListener('focus', handleFocus);
    //         textarea.removeEventListener('blur', handleBlur);
    //     };
    // }, []);
    //  const editor = editorRef.current;
    //     editor.addEventListener('focus', handleFocus);
    //     editor.addEventListener('blur', handleBlur);

    //     return () => {
    //         editor.removeEventListener('focus', handleFocus);
    //         editor.removeEventListener('blur', handleBlur);
    //     };
    // }, []);

        // Update placeholder visibility
    useEffect(() => {
        if (editorRef.current) {
            const hasContent = editorRef.current.innerText.trim() !== '';
            setShowPlaceholder(!hasContent && !isEditorFocused);
        }
    }, [message, isEditorFocused]);



    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        if (selectedFile) {
            setFile(selectedFile);
            if (selectedFile.type.startsWith('image/')) {
                setPreview(URL.createObjectURL(selectedFile));
            } else if (selectedFile.type.startsWith('video/')) {
                setPreview(URL.createObjectURL(selectedFile));
            }
        }
    };

    const removeFile = () => {
        setFile(null);
        setPreview(null);
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
    };

    const handleKeyDown = (e) => {
        // On mobile, Enter key should always create new line
        if (isMobile() && e.key === 'Enter') {
            return; // Let the default behavior (new line) happen
        }
        
        // On desktop, Enter sends message, Shift+Enter creates new line
        if (!isMobile() && e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            onSubmitHandler(e);
        }
    };

    const handlePaste = (e) => {
        const pastedText = e.clipboardData.getData('text/plain');
        const startPos = e.target.selectionStart;
        const endPos = e.target.selectionEnd;
        
        setMessage(prev => 
            prev.substring(0, startPos) + pastedText + prev.substring(endPos)
        );
        
        e.preventDefault();
        
        setTimeout(() => {
            textareaRef.current.selectionStart = startPos + pastedText.length;
            textareaRef.current.selectionEnd = startPos + pastedText.length;
        }, 0);
    };

    // const onEmojiClick = (emojiData) => {
    //     const emoji = emojiData.emoji;
    //     const textarea = textareaRef.current;
    //     const start = textarea.selectionStart;
    //     const end = textarea.selectionEnd;
        
    //     setMessage(prev => 
    //         prev.substring(0, start) + emoji + prev.substring(end)
    //     );
        
    //     setTimeout(() => {
    //         textarea.selectionStart = start + emoji.length;
    //         textarea.selectionEnd = start + emoji.length;
    //         textarea.focus();
    //     }, 0);
    // };

     const onEmojiClick = (emojiData) => {
        const emoji = emojiData.emoji;
        const editor = editorRef.current;
          if (!editor) return;

        let selection = window.getSelection();

          if (savedSelectionRef.current) {
            selection.removeAllRanges();
            selection.addRange(savedSelectionRef.current);
        }
        
        // Create text node for emoji
        const textNode = document.createTextNode(emoji);
        
        if (selection.rangeCount > 0) {
            const range = selection.getRangeAt(0);
            range.deleteContents();
            // const textNode = document.createTextNode(emoji);
            range.insertNode(textNode);
            range.setStartAfter(textNode);
            // range.setEndAfter(textNode);
            // selection.removeAllRanges();
            // selection.addRange(range);
          
              range.collapse(true);
        } else {
            // editor.innerHTML += emoji;
            editor.appendChild(textNode);
        }
        
         // Update content
        // setMessage(editor.innerText);
         
           updateContent();
        editor.focus();
        // updateContent();
       savedSelectionRef.current = null; 
    };

    // const toggleEmojiPicker = () => {
    //     if (isMobile()) {
    //         if (showEmojiPicker) {
    //             setShowEmojiPicker(false);
    //             setTimeout(() => {
    //                 // textareaRef.current.focus();
    //                 editorRef.current.focus();
    //             }, 100);
    //         } else {
    //             // textareaRef.current.blur();
    //             setShowFormatOptions(false);
    //             setTimeout(() => {
    //                 setShowEmojiPicker(true);
    //             }, 100);
    //         }
    //     } else {
    //         setShowEmojiPicker(prev => !prev);
    //          setShowFormatOptions(false);
    //     }
    // };

     const toggleEmojiPicker = () => {
        setShowFormatOptions(false);
        
        // Save current selection before opening picker
        const selection = window.getSelection();
        if (selection.rangeCount > 0) {
            savedSelectionRef.current = selection.getRangeAt(0).cloneRange();
        }
        
        setShowEmojiPicker(prev => !prev);
    };

    //     const toggleFormatOptions = () => {
    //     if (isMobile()) {
    //         if (showFormatOptions) {
    //             setShowFormatOptions(false);
    //             setTimeout(() => {
    //                 editorRef.current.focus();
    //             }, 100);
    //         } else {
    //             setShowEmojiPicker(false);
    //             setTimeout(() => {
    //                 setShowFormatOptions(true);
    //             }, 100);
    //         }
    //     } else {
    //         setShowFormatOptions(prev => !prev);
    //         setShowEmojiPicker(false);
    //     }
    // };

        const toggleFormatOptions = () => {
        setShowEmojiPicker(false);
        setShowFormatOptions(prev => !prev);
    };

    // const updateContent = () => {
    //     const editor = editorRef.current;
    //     const plainText = editor.innerText;
    //     const htmlContent = editor.innerHTML;
        
    //     setMessage(plainText);
    //     setFormattedContent(htmlContent);
    // };

    // const applyFormatting = (format) => {
    //     const editor = editorRef.current;
    //     const selection = window.getSelection();
        
    //     if (selection.rangeCount === 0) return;
        
    //     const range = selection.getRangeAt(0);
    //     const selectedText = range.toString();
        
    //     if (!selectedText && !range.collapsed) return;
        
    //     document.execCommand(format, false, null);
    //     editor.focus();
    //     updateContent();
    // };

        // Update content handler
    const updateContent = () => {
        const editor = editorRef.current;
        if (!editor) return;
        
        const plainText = editor.innerText;
        const htmlContent = editor.innerHTML;
        
        setMessage(plainText);
        setFormattedContent(htmlContent); // NEW: Store formatted HTML
    };

    const applyFormatting = (format) => {
        const editor = editorRef.current;
        if (!editor) return;
        
        document.execCommand(format, false, null);
        // setMessage(editor.innerText);
        updateContent(); 
        editor.focus();
    };



     // Add temporary message to show while sending
     const addTemporaryMessage = () => {
           const editor = editorRef.current;
        if (!editor) return null;
        
        const plainText = editor.innerText.trim();
         const htmlContent = editor.innerHTML;

        const tempMessage = {
            _id: `temp-${Date.now()}`,
            senderId: authUser._id,
            receiverId: selectedUser?._id || 'admins',
            // message: message.trim(),
            message: plainText,
            formattedMessage: htmlContent,
            imageUrl: file?.type?.startsWith('image/') ? 'temp-image' : null,
            videoUrl: file?.type?.startsWith('video/') ? 'temp-video' : null,
            status: "sending",
            createdAt: new Date().toISOString(),
            isTemp: true
        };
        dispatch(addNewMessage(tempMessage));
        return tempMessage._id;
    };

    // Remove temporary message when real message arrives
    const removeTemporaryMessage = (tempId) => {
        dispatch(deleteMessage(tempId));
    };


    const onSubmitHandler = async (e) => {
        e.preventDefault();
        // if (!message.trim() && !file) return;

                const editor = editorRef.current;
        if (!editor) return;

                const plainText = editor.innerText.trim();
        if (!plainText && !file) return;


        if (isSending) return; // Prevent multiple sends

        setIsSending(true);
        const tempMessageId = addTemporaryMessage();

    
        try {
            let receiverId = null;
          
            if (authUser?.isRole === 1) {
                // Admin sending to specific user
                if (!selectedUser?._id) {
                    toast.error("Please select a user to chat with");
                    setIsSending(false);
                    removeTemporaryMessage(tempMessageId);

                    return;
                }
                receiverId = selectedUser._id;
                    // Send SMS notification if admin is messaging a user with mobile number
            if (selectedUser?.mobileNumber && plainText) {
                await sendSMSNotification(selectedUser.mobileNumber, plainText);
            }
            } else {
                // Regular user - message will go to all admins (handled by backend)
                receiverId = 'admins';

                 // Send SMS to ALL admins if user is messaging
            if (plainText) {
                const admins = await axios.get(`${BASE_URL}/api/v1/user/admins`, {
                    withCredentials: true
                });
                
                // Send SMS to each admin who has mobile number
                for (const admin of admins.data) {
                    if (admin?.mobileNumber) {
                        await sendSMSNotification(admin.mobileNumber,plainText);
                    }
                }
            }
               
            }
    
            const formData = new FormData();
            // if (message.trim()) formData.append('message', message.trim());
             if (plainText) {
                formData.append('message', plainText);
                formData.append('formattedMessage', formattedContent); 
            }
          
            if (file) formData.append('image', file);
            if (originalMessageId) formData.append('originalMessageId', originalMessageId);
           
            const config = {
                withCredentials: true,
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            };
    
            // Use the same endpoint for both cases - backend will handle the routing
        const res = await axios.post(
            `${BASE_URL}/api/v1/message/send/${receiverId}`, 
            formData, 
            config
        );
    
                    // Replace temporary message with real one
                    removeTemporaryMessage(tempMessageId);

            // dispatch(setMessages([...messages, res?.data?.newMessage]));
            // dispatch(addNewMessage(res?.data?.newMessage));
            //    const newMessage = {
            //     ...res?.data?.newMessage,
            //     formattedMessage: formattedContent
            // };
            
            // dispatch(addNewMessage(newMessage));
            dispatch(addNewMessage(res?.data?.newMessage));
            editor.innerHTML = "";
            setMessage("");
            //  setFormattedContent("");
            setFile(null);
            setPreview(null);
            if (fileInputRef.current) {
                fileInputRef.current.value = "";
            }
            setShowEmojiPicker(false);
             setShowFormatOptions(false);

              // Reset placeholder
            setShowPlaceholder(true);
            
            // // On mobile, focus the input after sending
            // if (isMobile()) {
            //     setTimeout(() => {
            //         // textareaRef.current.focus();
            //        editorRef.current.focus();

            //     }, 100);
            // }
            setOriginalMessageId(null);
        } catch (error) {
            console.log("Error sending message:", error);
            removeTemporaryMessage(tempMessageId);
            toast.error(error.response?.data?.message || "Failed to send message");
        } 
     finally {
        setIsSending(false);
    }
    };

    // Auto-resize textarea based on content
    const adjustTextareaHeight = () => {
        if (textareaRef.current) {
            textareaRef.current.style.height = 'auto';
            const maxHeight = 150;
            const newHeight = Math.min(textareaRef.current.scrollHeight, maxHeight);
            textareaRef.current.style.height = `${newHeight}px`;
            
            // Scroll to bottom of form when textarea expands
            if (formRef.current) {
                formRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
            }
        }
    };

    useEffect(() => {
        adjustTextareaHeight();
    }, [message]);

        // Adjust toolbar position for mobile keyboard
    useEffect(() => {
        if (!isMobile()) return;
        
        const handleResize = () => {
            const editor = editorRef.current;
            if (editor) {
                const rect = editor.getBoundingClientRect();
                const isKeyboardOpen = window.innerHeight - rect.bottom > 200;
                setIsMobileKeyboardOpen(!isKeyboardOpen);
            }
        };
        
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);


     useEffect(() => {
        // Update message state when editor content changes
        const handleInput = () => {
            if (editorRef.current) {
                setMessage(editorRef.current.innerText);
                setShowPlaceholder(editorRef.current.innerText.trim() === '' && !isEditorFocused);
            }
        };

        const editor = editorRef.current;
        if (editor) {
            editor.addEventListener('input', handleInput);
        }

        return () => {
            if (editor) {
                editor.removeEventListener('input', handleInput);
            }
        };
    }, [isEditorFocused]);
    return (
                 <form ref={formRef} onSubmit={onSubmitHandler} className='px-2 md:px-4 my-2'>
            {preview && (
                <div className="relative mb-2">
                    {file?.type?.startsWith('image/') ? (
                        <img 
                            src={preview} 
                            alt="Preview" 
                            className="max-h-40 rounded-lg"
                        />
                    ) : file?.type?.startsWith('video/') ? (
                        <video 
                            src={preview} 
                            controls 
                            className="max-h-40 rounded-lg"
                        />
                    ) : null}
                    <button 
                        type="button"
                        onClick={removeFile}
                        className="absolute top-1 right-1 bg-gray-800 text-white rounded-full p-1"
                    >
                         ✖
                    </button>
                </div>
            )}
            <div className='relative w-full flex items-end'>
                {showEmojiPicker && (
                    <div 
                        ref={emojiPickerRef}
                        className={`absolute z-10 shadow-lg rounded-t-lg overflow-hidden ${
                            isMobile() ? 
                                'bottom-full left-0 right-0 mb-1' : // Mobile: above input
                                'bottom-full right-0 mb-2'  // Desktop: above input at right
                        }`}
                        style={{
                            width: isMobile() ? '100%' : '300px',
                        }}
                    >
                        <EmojiPicker 
                            onEmojiClick={onEmojiClick}
                            width={isMobile() ? '100%' : 300}
                            height={350}
                            previewConfig={{showPreview: false}}
                            skinTonesDisabled
                            searchDisabled={false}
                            lazyLoadEmojis
                            theme="light"
                            suggestedEmojisMode="frequent"
                            emojiStyle="native"
                            className="emoji-picker"
                            style={{
                                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
                                border: '1px solid #e5e7eb',
                                borderRadius: isMobile() ? '0.5rem 0.5rem 0 0' : '0.5rem 0.5rem 0 0',
                                width: '100%'
                            }}
                        />
                    </div>
                )}

                                {showFormatOptions && (
                    <div 
                        ref={formatOptionsRef}
                        className={`absolute z-10 bg-gray-100 shadow-lg rounded-lg p-2 ${
                            isMobile() ? 
                                'bottom-full left-0 right-0 mb-1' : 
                                'bottom-full left-0 mb-2'
                        }`}
                        style={{
                            // width: isMobile() ? '100%' : '100%',
                                        width: '100%',

                        }}
                    >
                        <div className="flex space-x-2 justify-start">
                            <button 
                                type="button"
                                onClick={() => applyFormatting('bold')}
                                className="p-1 px-2 rounded hover:bg-gray-200"
                                title="Bold"
                            >
                                <span className="font-bold">B</span>
                            </button>
                            <button 
                                type="button"
                                onClick={() => applyFormatting('italic')}
                                className="p-1 px-2 rounded hover:bg-gray-200"
                                title="Italic"
                            >
                                <span className="italic">I</span>
                            </button>
                            <button 
                                type="button"
                                onClick={() => applyFormatting('strikeThrough')}
                                className="p-1 px-2 rounded hover:bg-gray-200"
                                title="Strikethrough"
                            >
                                <span className="line-through">S</span>
                            </button>
                        </div>
                    </div>
                )}
                

                   <div className="relative flex-grow">
                {/* <textarea
                    ref={textareaRef}
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    onKeyDown={handleKeyDown}
                    onPaste={handlePaste}
                    placeholder='Send a message...'
                    rows={1}
                    className='border text-sm rounded-lg block w-full p-2 md:p-3 pr-12 border-zinc-500 bg-white text-gray-800 overflow-hidden'
                    style={{
                        minHeight: '44px',
                        resize: 'none',
                          paddingRight: '5.5rem',
                    }}
                    disabled={isSending} 
                /> */}

                                    <div
                        ref={editorRef}
                        contentEditable
                        onInput={updateContent}
                        onKeyDown={handleKeyDown}
                        // placeholder='Send a message...'
                        onFocus={() => setIsEditorFocused(true)}
                        onBlur={() => setIsEditorFocused(false)}

                        className='border text-sm rounded-lg block w-full p-2 md:p-3 pr-12 border-zinc-500 bg-white text-gray-800 overflow-hidden min-h-[44px] max-h-[150px] overflow-y-auto relative'
                        style={{
                            outline: 'none',
                            resize: 'none',
                        }}
                    />
                 {showPlaceholder && (
                        <div className="absolute top-3 left-3 text-gray-500 pointer-events-none">
                            Send a message...
                        </div>
                    )}

                <div className="absolute right-2 bottom-2 flex items-center space-x-2">

                      <button 
                            type="button" 
                            className="format-trigger text-gray-500 hover:text-gray-700"
                            onClick={toggleFormatOptions}
                        >
                            {/* <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M4 7h16"></path>
                                <path d="M10 11h4"></path>
                                <path d="M10 15h4"></path>
                                <path d="M5 20h14"></path>
                                <path d="M6 3v4"></path>
                                <path d="M18 3v4"></path>
                                <path d="M6 8v8"></path>
                                <path d="M18 8v8"></path>
                            </svg> */}
                                <span className="font-bold text-lg">A</span>

                        </button>
                        

                    <button 
                        type="button" 
                        className="emoji-trigger text-gray-500 hover:text-gray-700"
                        onClick={toggleEmojiPicker}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                            <circle cx="12" cy="12" r="10"></circle>
                            <path d="M8 14s1.5 2 4 2 4-2 4-2"></path>
                            <line x1="9" y1="9" x2="9.01" y2="9"></line>
                            <line x1="15" y1="9" x2="15.01" y2="9"></line>
                        </svg>
                    </button>
                    <label className="cursor-pointer text-gray-500 hover:text-gray-700">
                        <IoImageOutline className="text-lg md:text-xl" />
                        <input
                            type="file"
                            ref={fileInputRef}
                            onChange={handleFileChange}
                            accept="image/*,video/*"
                            className="hidden"
                        />
                    </label>
                    {/* <button 
                        type="submit" 
                        className='text-green-500 hover:text-green-600'
                        disabled={(!message.trim() && !file) || isSending}
                    > */}
                        {/* <IoSend className="text-lg md:text-xl" />/ */}
                        {/* {isSending ? (
                            <div className="w-4 h-4 border-2 border-green-500 border-t-transparent rounded-full animate-spin"></div>
                        ) : (
                            <IoSend className="text-lg md:text-xl" />
                        )}
                    </button> */}
                      <button 
                        type="submit" 
                        className={`flex items-center justify-center ${isSending ? 'text-gray-400' : 'text-green-500 hover:text-green-600'}`}
                        // disabled={(!message.trim() && !file) || isSending}
                         disabled={ isSending}
                    >
                        {/* {isSending ? (
                            <div className="flex items-center justify-center">
                                <div className="relative w-5 h-5">
                                    <div className="absolute inset-0 flex items-center justify-center">
                                        <div className="w-4 h-4 border-2 border-gray-400 rounded-full"></div>
                                    </div>
                                    <div className="absolute inset-0 flex items-center justify-center animate-spin">
                                        <div className="w-4 h-4 border-2 border-gray-400 border-t-transparent rounded-full"></div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <IoSend className="text-lg md:text-xl" />
                        )} */}

{isSending ? (
  <div className="relative w-5 h-5">
    <div className="absolute inset-0 rounded-full border-2 border-green-400"></div>
    <div className="absolute inset-0 rounded-full border-2 border-t-green-500 border-r-green-500 border-b-transparent border-l-transparent animate-spin"></div>
  </div>
) : (
  <IoSend className="text-lg md:text-xl" />
)}
                    </button>

                </div>
            </div>
              </div>
        </form>
    );
}

export default SendInput; 


// import React, {useState, useRef, useEffect} from 'react'
// import { IoSend, IoImageOutline } from "react-icons/io5";
// import { EmojiClickData } from 'emoji-picker-react';
// import EmojiPicker from 'emoji-picker-react';
// import axios from "axios";
// import {useDispatch, useSelector} from "react-redux";
// import { setMessages ,addNewMessage, deleteMessage} from '../redux/messageSlice';
// import { BASE_URL } from '../config';
// import toast from 'react-hot-toast';
// import { debounce } from 'lodash'; 

// const SendInput = () => {
//     const [message, setMessage] = useState("");
//     const [file, setFile] = useState(null);
//     const [preview, setPreview] = useState(null);
//     const [showEmojiPicker, setShowEmojiPicker] = useState(false);
//     const [isMobileKeyboardOpen, setIsMobileKeyboardOpen] = useState(false);
//     const [isSending, setIsSending] = useState(false); // New loading state
//     const fileInputRef = useRef(null);
//     const textareaRef = useRef(null);
//     const emojiPickerRef = useRef(null);
//     const formRef = useRef(null);
//     const dispatch = useDispatch();
//     const {selectedUser, authUser} = useSelector(store=>store.user);
//     const {messages} = useSelector(store=>store.message);
//     const [originalMessageId, setOriginalMessageId] = useState(null);
//     const { socket } = useSelector(store => store.socket);
    

//     // Check if user is on mobile device
//     const isMobile = () => {
//         return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
//     };



//     // Updated SMS notification function
// const sendSMSNotification = async (mobileNumber, messageContent) => {
//     try {
//       await axios.post(
//         `${BASE_URL}/api/v1/send-notification`, // Your backend proxy route
//         {
//           mobile_number: mobileNumber,
//           message: messageContent
//         },
//         {
//           withCredentials: true,
//           headers: {
//             "Content-Type": "application/json",
//             "accept": "application/json"
//           }
//         }
//       );
//     } catch (error) {
//       console.error("SMS notification failed:", error);
//     }
//   };


// // }, [message, socket, authUser, selectedUser]);

// useEffect(() => {
//     if (!socket || !authUser || !selectedUser) return;

//     let typing = false;
//     let timeout;

//     const handleKeyPress = () => {
//         if (!typing) {
//             typing = true;
//             socket.emit('typing', {
//                 senderId: authUser._id,
//                 receiverId: selectedUser._id,
//                 nickname: authUser.nickname || authUser.username
//             });
//         }
//         clearTimeout(timeout);
//         timeout = setTimeout(() => {
//             typing = false;
//             socket.emit('stopTyping', {
//                 senderId: authUser._id,
//                 receiverId: selectedUser._id
//             });
//         }, 3000); // Send stopTyping after 1 second of inactivity
//     };

//     const textarea = textareaRef.current;
//     textarea.addEventListener('keydown', handleKeyPress);

//     return () => {
//         textarea.removeEventListener('keydown', handleKeyPress);
//         clearTimeout(timeout);
//         if (typing) {
//             socket.emit('stopTyping', {
//                 senderId: authUser._id,
//                 receiverId: selectedUser._id
//             });
//         }
//     };
// }, [message, socket, authUser, selectedUser]);

//     // Handle clicks outside emoji picker to close it
//     useEffect(() => {
//         const handleClickOutside = (event) => {
//             if (emojiPickerRef.current && !emojiPickerRef.current.contains(event.target) && 
//                 !event.target.closest('.emoji-trigger')) {
//                 setShowEmojiPicker(false);
//             }
//         };
//         document.addEventListener('mousedown', handleClickOutside);
//         return () => {
//             document.removeEventListener('mousedown', handleClickOutside);
//         };
//     }, []);

//     // Handle mobile keyboard visibility changes
//     useEffect(() => {
//         if (!isMobile()) return;

//         const handleFocus = () => {
//             setIsMobileKeyboardOpen(true);
//             setShowEmojiPicker(false);
//         };

//         const handleBlur = () => {
//             setIsMobileKeyboardOpen(false);
//         };

//         const textarea = textareaRef.current;
//         textarea.addEventListener('focus', handleFocus);
//         textarea.addEventListener('blur', handleBlur);

//         return () => {
//             textarea.removeEventListener('focus', handleFocus);
//             textarea.removeEventListener('blur', handleBlur);
//         };
//     }, []);

//     const handleFileChange = (e) => {
//         const selectedFile = e.target.files[0];
//         if (selectedFile) {
//             setFile(selectedFile);
//             if (selectedFile.type.startsWith('image/')) {
//                 setPreview(URL.createObjectURL(selectedFile));
//             } else if (selectedFile.type.startsWith('video/')) {
//                 setPreview(URL.createObjectURL(selectedFile));
//             }
//         }
//     };

//     const removeFile = () => {
//         setFile(null);
//         setPreview(null);
//         if (fileInputRef.current) {
//             fileInputRef.current.value = "";
//         }
//     };

//     const handleKeyDown = (e) => {
//         // On mobile, Enter key should always create new line
//         if (isMobile() && e.key === 'Enter') {
//             return; // Let the default behavior (new line) happen
//         }
        
//         // On desktop, Enter sends message, Shift+Enter creates new line
//         if (!isMobile() && e.key === 'Enter' && !e.shiftKey) {
//             e.preventDefault();
//             onSubmitHandler(e);
//         }
//     };

//     const handlePaste = (e) => {
//         const pastedText = e.clipboardData.getData('text/plain');
//         const startPos = e.target.selectionStart;
//         const endPos = e.target.selectionEnd;
        
//         setMessage(prev => 
//             prev.substring(0, startPos) + pastedText + prev.substring(endPos)
//         );
        
//         e.preventDefault();
        
//         setTimeout(() => {
//             textareaRef.current.selectionStart = startPos + pastedText.length;
//             textareaRef.current.selectionEnd = startPos + pastedText.length;
//         }, 0);
//     };

//     const onEmojiClick = (emojiData) => {
//         const emoji = emojiData.emoji;
//         const textarea = textareaRef.current;
//         const start = textarea.selectionStart;
//         const end = textarea.selectionEnd;
        
//         setMessage(prev => 
//             prev.substring(0, start) + emoji + prev.substring(end)
//         );
        
//         setTimeout(() => {
//             textarea.selectionStart = start + emoji.length;
//             textarea.selectionEnd = start + emoji.length;
//             textarea.focus();
//         }, 0);
//     };

//     const toggleEmojiPicker = () => {
//         if (isMobile()) {
//             if (showEmojiPicker) {
//                 setShowEmojiPicker(false);
//                 setTimeout(() => {
//                     textareaRef.current.focus();
//                 }, 100);
//             } else {
//                 textareaRef.current.blur();
//                 setTimeout(() => {
//                     setShowEmojiPicker(true);
//                 }, 100);
//             }
//         } else {
//             setShowEmojiPicker(prev => !prev);
//         }
//     };

//      // Add temporary message to show while sending
//      const addTemporaryMessage = () => {
//         const tempMessage = {
//             _id: `temp-${Date.now()}`,
//             senderId: authUser._id,
//             receiverId: selectedUser?._id || 'admins',
//             message: message.trim(),
//             imageUrl: file?.type?.startsWith('image/') ? 'temp-image' : null,
//             videoUrl: file?.type?.startsWith('video/') ? 'temp-video' : null,
//             status: "sending",
//             createdAt: new Date().toISOString(),
//             isTemp: true
//         };
//         dispatch(addNewMessage(tempMessage));
//         return tempMessage._id;
//     };

//     // Remove temporary message when real message arrives
//     const removeTemporaryMessage = (tempId) => {
//         dispatch(deleteMessage(tempId));
//     };


//     const onSubmitHandler = async (e) => {
//         e.preventDefault();
//         if (!message.trim() && !file) return;

//         if (isSending) return; // Prevent multiple sends

//         setIsSending(true);
//         const tempMessageId = addTemporaryMessage();

    
//         try {
//             let receiverId = null;
          
//             if (authUser?.isRole === 1) {
//                 // Admin sending to specific user
//                 if (!selectedUser?._id) {
//                     toast.error("Please select a user to chat with");
//                     setIsSending(false);
//                     removeTemporaryMessage(tempMessageId);

//                     return;
//                 }
//                 receiverId = selectedUser._id;
//                     // Send SMS notification if admin is messaging a user with mobile number
//             if (selectedUser?.mobileNumber && message.trim()) {
//                 await sendSMSNotification(selectedUser.mobileNumber, message.trim());
//             }
//             } else {
//                 // Regular user - message will go to all admins (handled by backend)
//                 receiverId = 'admins';

//                  // Send SMS to ALL admins if user is messaging
//             if (message.trim()) {
//                 const admins = await axios.get(`${BASE_URL}/api/v1/user/admins`, {
//                     withCredentials: true
//                 });
                
//                 // Send SMS to each admin who has mobile number
//                 for (const admin of admins.data) {
//                     if (admin?.mobileNumber) {
//                         await sendSMSNotification(admin.mobileNumber, message.trim());
//                     }
//                 }
//             }
               
//             }
    
//             const formData = new FormData();
//             if (message.trim()) formData.append('message', message.trim());
//             if (file) formData.append('image', file);
//             if (originalMessageId) formData.append('originalMessageId', originalMessageId);
           
//             const config = {
//                 withCredentials: true,
//                 headers: {
//                     'Content-Type': 'multipart/form-data',
//                 }
//             };
    
//             // Use the same endpoint for both cases - backend will handle the routing
//         const res = await axios.post(
//             `${BASE_URL}/api/v1/message/send/${receiverId}`, 
//             formData, 
//             config
//         );
    
//                     // Replace temporary message with real one
//                     removeTemporaryMessage(tempMessageId);

//             // dispatch(setMessages([...messages, res?.data?.newMessage]));
//             dispatch(addNewMessage(res?.data?.newMessage));
//             setMessage("");
//             setFile(null);
//             setPreview(null);
//             if (fileInputRef.current) {
//                 fileInputRef.current.value = "";
//             }
//             setShowEmojiPicker(false);
            
//             // On mobile, focus the input after sending
//             if (isMobile()) {
//                 setTimeout(() => {
//                     textareaRef.current.focus();
//                 }, 100);
//             }
//             setOriginalMessageId(null);
//         } catch (error) {
//             console.log("Error sending message:", error);
//             removeTemporaryMessage(tempMessageId);
//             toast.error(error.response?.data?.message || "Failed to send message");
//         } 
//      finally {
//         setIsSending(false);
//     }
//     };

//     // Auto-resize textarea based on content
//     const adjustTextareaHeight = () => {
//         if (textareaRef.current) {
//             textareaRef.current.style.height = 'auto';
//             const maxHeight = 150;
//             const newHeight = Math.min(textareaRef.current.scrollHeight, maxHeight);
//             textareaRef.current.style.height = `${newHeight}px`;
            
//             // Scroll to bottom of form when textarea expands
//             if (formRef.current) {
//                 formRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
//             }
//         }
//     };

//     useEffect(() => {
//         adjustTextareaHeight();
//     }, [message]);

//     return (
//                  <form ref={formRef} onSubmit={onSubmitHandler} className='px-2 md:px-4 my-2'>
//             {preview && (
//                 <div className="relative mb-2">
//                     {file?.type?.startsWith('image/') ? (
//                         <img 
//                             src={preview} 
//                             alt="Preview" 
//                             className="max-h-40 rounded-lg"
//                         />
//                     ) : file?.type?.startsWith('video/') ? (
//                         <video 
//                             src={preview} 
//                             controls 
//                             className="max-h-40 rounded-lg"
//                         />
//                     ) : null}
//                     <button 
//                         type="button"
//                         onClick={removeFile}
//                         className="absolute top-1 right-1 bg-gray-800 text-white rounded-full p-1"
//                     >
//                          ✖
//                     </button>
//                 </div>
//             )}
//             <div className='relative w-full flex items-end'>
//                 {showEmojiPicker && !isMobileKeyboardOpen && (
//                     <div 
//                         ref={emojiPickerRef}
//                         className={`absolute z-10 shadow-lg rounded-t-lg overflow-hidden ${
//                             isMobile() ? 
//                                 'bottom-full left-0 right-0 mb-1' : // Mobile: above input
//                                 'bottom-full right-0 mb-2'  // Desktop: above input at right
//                         }`}
//                         style={{
//                             width: isMobile() ? '100%' : '300px',
//                         }}
//                     >
//                         <EmojiPicker 
//                             onEmojiClick={onEmojiClick}
//                             width={isMobile() ? '100%' : 300}
//                             height={350}
//                             previewConfig={{showPreview: false}}
//                             skinTonesDisabled
//                             searchDisabled={false}
//                             lazyLoadEmojis
//                             theme="light"
//                             suggestedEmojisMode="frequent"
//                             emojiStyle="native"
//                             className="emoji-picker"
//                             style={{
//                                 boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
//                                 border: '1px solid #e5e7eb',
//                                 borderRadius: isMobile() ? '0.5rem 0.5rem 0 0' : '0.5rem 0.5rem 0 0',
//                                 width: '100%'
//                             }}
//                         />
//                     </div>
//                 )}
//                    <div className="relative flex-grow">
//                 <textarea
//                     ref={textareaRef}
//                     value={message}
//                     onChange={(e) => setMessage(e.target.value)}
//                     onKeyDown={handleKeyDown}
//                     onPaste={handlePaste}
//                     placeholder='Send a message...'
//                     rows={1}
//                     className='border text-sm rounded-lg block w-full p-2 md:p-3 pr-12 border-zinc-500 bg-white text-gray-800 overflow-hidden'
//                     style={{
//                         minHeight: '44px',
//                         resize: 'none',
//                           paddingRight: '5.5rem',
//                     }}
//                     disabled={isSending} 
//                 />
//                 <div className="absolute right-2 bottom-2 flex items-center space-x-2">
//                     <button 
//                         type="button" 
//                         className="emoji-trigger text-gray-500 hover:text-gray-700"
//                         onClick={toggleEmojiPicker}
//                     >
//                         <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
//                             <circle cx="12" cy="12" r="10"></circle>
//                             <path d="M8 14s1.5 2 4 2 4-2 4-2"></path>
//                             <line x1="9" y1="9" x2="9.01" y2="9"></line>
//                             <line x1="15" y1="9" x2="15.01" y2="9"></line>
//                         </svg>
//                     </button>
//                     <label className="cursor-pointer text-gray-500 hover:text-gray-700">
//                         <IoImageOutline className="text-lg md:text-xl" />
//                         <input
//                             type="file"
//                             ref={fileInputRef}
//                             onChange={handleFileChange}
//                             accept="image/*,video/*"
//                             className="hidden"
//                         />
//                     </label>
                
//                       <button 
//                         type="submit" 
//                         className={`flex items-center justify-center ${isSending ? 'text-gray-400' : 'text-green-500 hover:text-green-600'}`}
//                         disabled={(!message.trim() && !file) || isSending}
//                     >


// {isSending ? (
//   <div className="relative w-5 h-5">
//     <div className="absolute inset-0 rounded-full border-2 border-green-400"></div>
//     <div className="absolute inset-0 rounded-full border-2 border-t-green-500 border-r-green-500 border-b-transparent border-l-transparent animate-spin"></div>
//   </div>
// ) : (
//   <IoSend className="text-lg md:text-xl" />
// )}
//                     </button>

//                 </div>
//             </div>
//               </div>
//         </form>
//     );
// }

// export default SendInput; 



